import { jsx as _jsx } from "react/jsx-runtime";
import { LayoutDistribution } from './Layout.style';
const Layout = ({ children, ...props }) => (_jsx(LayoutDistribution, { ...props, children: children }));
export default Layout;
